const initCarousel = (carousel) => {
    carousel
        .querySelectorAll('.carousel__row-elements .carousel__item')
        .forEach((item) => {
        item.addEventListener('click', () => showCarouselItemPopup(carousel, item.dataset.itemId || null));
    });
    const closePopupButton = carousel.querySelector('.carousel__popup-close');
    if (closePopupButton) {
        closePopupButton.addEventListener('click', () => hidePopup(carousel));
    }
};
const hidePopup = (carousel) => {
    carousel.classList.toggle('carousel--popup-shown', false);
};
const showCarouselItemPopup = (carousel, itemId) => {
    if (!itemId) {
        return;
    }
    carousel
        .querySelectorAll('.carousel__popup .carousel__item')
        .forEach((currentItem) => (currentItem.style.display = currentItem.dataset.itemId == itemId ? 'block' : 'none'));
    carousel.classList.toggle('carousel--popup-shown', true);
};
export const initCarousels = () => {
    document.querySelectorAll('.carousel').forEach((carousel) => initCarousel(carousel));
};
